module.exports = __webpack_public_path__ + "img/emoji-3.3fe0dfbe.png";